module.exports = __webpack_public_path__ + "img/tree-04-b-leaves.cfab7123.png";